import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Dashboard from "@/pages/Dashboard";
import HowToUse from "@/pages/HowToUse";
import { AuthProvider } from "@/context/AuthContext";
import AuthModal from "@/components/AuthModal";
import AnonymousInteractionGate from "@/components/AnonymousInteractionGate";

const TOAST_OPTIONS = {
  style: {
    background: '#13131A',
    border: '1px solid #1F2937',
    color: '#F3F4F6',
    fontFamily: 'JetBrains Mono, monospace',
    fontSize: '12px'
  }
};

function App() {
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(false);

  return (
    <AuthProvider>
      <div className="App dark bg-[#0A0C10] h-screen h-[100dvh] max-h-screen flex flex-col overflow-hidden">
        <BrowserRouter>
          <Navbar
            isCollapsed={isNavbarCollapsed}
            onToggleCollapse={() => setIsNavbarCollapsed(!isNavbarCollapsed)}
          />
          <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
            <AnonymousInteractionGate>
              <Routes>
                <Route
                  path="/"
                  element={
                    <Dashboard
                      isNavbarCollapsed={isNavbarCollapsed}
                      onToggleNavbar={() => setIsNavbarCollapsed(!isNavbarCollapsed)}
                    />
                  }
                />
                <Route path="/how-to-use" element={<HowToUse />} />
              </Routes>
            </AnonymousInteractionGate>
          </div>
        </BrowserRouter>
        <AuthModal />
        <Toaster position="bottom-right" toastOptions={TOAST_OPTIONS} />
      </div>
    </AuthProvider>
  );
}

export default App;
